import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/buildhome/repo/src/layouts/blogPost.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Today we’re excited to introduce `}<strong parentName="p"><a parentName="strong" {...{
          "href": "https://sybil.org/"
        }}>{`Sybil`}</a>{`, a governance tool for discovering delegates.`}</strong>{` Sybil `}<strong parentName="p">{`maps on-chain addresses to digital identities`}</strong>{` to maintain a list of delegates, all while avoiding pesky user signups, on-chain transactions, and manual record keeping.`}</p>
    <p>{`We hope that Sybil can grow adoption of Uniswap’s governance system and encourage both existing and future Uniswap delegates to verify their identities, `}<strong parentName="p">{`making it easier for delegators to discover and engage with their community representatives`}</strong>{`.`}</p>
    <h2 {...{
      "id": "the-importance-of-delegation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#the-importance-of-delegation",
        "aria-label": "the importance of delegation permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`The importance of delegation`}</h2>
    <p>{`Experimentation with on-chain governance systems continues to gain popularity, and for good reason! Community ownership reduces single points of failure and as protocols begin to develop into products that resemble legacy services — albeit in a structurally decentralized fashion — they naturally require good management.`}</p>
    <p>{`The ability for token holders to delegate their votes, or to stand as a delegate themselves, is key to the success of on-chain governance systems, allowing for high quality community members to build meaningful influence and otherwise-marginalized token holders to engage in a representative fashion. We believe that `}<strong parentName="p">{`the most successful protocols will be the ones that are able to attract the best talent and the most engaged communities.`}</strong></p>
    <p>{`Yet as an emerging primitive, delegation-based governance systems are still gaining some important infrastructure. Sybil’s purpose is to provide a simple way for governance token holders to identify their community representatives, and in doing so grow engagement in the protocol’s development process.`}</p>
    <h2 {...{
      "id": "how-it-works",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#how-it-works",
        "aria-label": "how it works permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`How it works`}</h2>
    <p><img parentName="p" {...{
        "src": "/fbb033af3ef1f1f42e2ff2999cbcd7e2/sybil.gif",
        "alt": null
      }}></img></p>
    <p>{`The Sybil verification flow is a three step process.`}</p>
    <ol>
      <li parentName="ol">{`Users sign into Twitter and connect a Web3 wallet`}</li>
      <li parentName="ol">{`Users sign a message that includes their Twitter handle using their private key`}</li>
      <li parentName="ol">{`Users then tweet this message from their Twitter account`}</li>
    </ol>
    <p>{`In the background, Sybil verifies that the tweet content matches the signed message. Once a user has been verified, their Twitter handle is matched to their Ethereum address and will appear on the Sybil interface next to their associated vote count. Sybil users can proceed to `}<strong parentName="p">{`review available delegates, as well as delegate or vote on governance proposals directly through the interface.`}</strong></p>
    <h2 {...{
      "id": "extending-sybil",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#extending-sybil",
        "aria-label": "extending sybil permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Extending Sybil`}</h2>
    <p>{`At launch, Sybil supports both Uniswap and Compound’s delegate lists but it’s mapping tool can be used to display public identities for any project.`}</p>
    <p>{`Identities work cross-platform, so users will only ever need to go through Sybil verification once per identity. For now, Sybil is solely integrated with Twitter, although the architecture allows for any other service to act as an authentication method: GitHub integration is coming soon!`}</p>
    <p>{`Sybil’s use cases extend beyond delegation. The mapping of addresses to social identities can be leveraged for features like trading and gaming leaderboards, as well as Ethereum-based messaging.`}</p>
    <p>{`Similarly, the Sybil verification process is not constrained to the Sybil.org interface. The documentation below provides detailed steps for both supporting the Sybil verification process directly from your existing interface and running custom verification flows around list creation.`}</p>
    <h2 {...{
      "id": "get-involed",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#get-involed",
        "aria-label": "get involed permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Get involed`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://sybil.org/"
          }}>{`Verify yourself as a delegate on Sybil.org`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://github.com/Uniswap/sybil-list#use-the-sybil-list"
          }}>{`Use the Sybil list`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://github.com/Uniswap/sybil-list#verify-your-own-list"
          }}>{`Verify your own list`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://github.com/Uniswap/sybil-interface"
          }}>{`Contribute to the Sybil interface`}</a></p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      